import React, { useEffect, useRef } from "react";
import EmojiPicker from "emoji-picker-react";

function EmojiPickerPopover({open,onEmojiClick,onClose,}) {
  const pickerRef = useRef(null);
  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener("mousedown",handleOutsideClick);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick,
      );
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
  <div
    ref={pickerRef}
    className=" absolute bottom-[72px] left-3 z-50 overflow-hidden rounded-xl border border-border-color bg-card-bg shadow-[0_10px_35px_rgba(15,23,42,0.14)] dark:border-dark-border dark:bg-dark-card dark:shadow-[0_10px_35px_rgba(0,0,0,0.35)]"
  >
    <EmojiPicker
      width={280}
      height={330}
      searchDisabled
      previewConfig={{
        showPreview: false,
      }}
      onEmojiClick={onEmojiClick}
    />
  </div>
);
}

export default EmojiPickerPopover;